export default "__VITE_ASSET__Bk1iyf$A__"